import {injectable} from "tsyringe";
import {UpdateIssueTypeCommand} from "../commands/update-issue-type.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {IssueType} from "../domain/entities/issue-type.entity";
import {TransformerHelper} from "../helpers/transformer.helper";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: UpdateIssueTypeCommand,
    target: `dto`
})
export class UpdateIssueTypeCommandToDtoTransformer extends AbstractCommandToDtoTransformer<IssueType> {

    protected async toDTO(issueType: IssueType): Promise<DataTransferObject> {
        return TransformerHelper.toDTO(issueType);
    }

}